"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m19.5831 8.19-5.5499-3.994-1.1683 1.6233 3.0326 2.1824H8.0982l3.0325-2.1824-1.1683-1.6234L4.4126 8.19l-.416.2994.0001.5125.0023 10 .0003.9998H19.999V8.4893l-.4159-.2993zM5.9969 10.0017H17.999v8H5.9988l-.0019-8zM10 14.0008h3.9999v-2h-4v2z"
  })];
};

exports.default = _default;